import React from 'react';
import { Navigate } from 'react-router-dom';
import { NFC_UI_VISIBLE } from '@/lib/nfcUiVisibility';

export default function NfcUiGate({ children }) {
  // Children never mount: no native initialization, API request or technical UI.
  return NFC_UI_VISIBLE ? children : <Navigate to="/foundation" replace />;
}
